<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/YCBwDp/cover.jpeg?1684514921557" alt="This image is the cover for the book Supreme Divine Book, Book 9"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Supreme Divine Book, Book 9
      </h1>
      <p class="bookDescription body article font2">
        <p><strong>With Gifted Divine Power, how would he achieve the legend of dominating the world? </strong></p><p></p><p>Han Chen was a distant disciple of a big sect called "Mystical Peak". He was humiliated by other disciples just because he didn't have the Gifted Divine Power, a special ability that God gave to human beings which existed in the human body with various forms. Even the most mediocre cultivator, the Gifted Divine Power in his body would wake up around the age of thirteen or fourteen.   Due to an accident, Han Chen had to pretend to be a member of Baofeng Gang and came to Wu Xiang abyss. Right here, Han Chen got the supreme divine book and his Gifted Divine Power was awakened.  Once being humiliated, Han Chen wanted everyone to know he was not a loser.  With Gifted Divine Power, how would he achieve the legend of dominating the world? </p><p></p><p><strong> ☆About the Author☆ </strong></p><p> Everyone has a Wuxia dream, so does the author of the novel, Shrimp-liking Fish (爱虾的鱼) . He‘s specializing in Wuxia web novels. His works include Supreme Divine Book (至尊神图), Evil Eyes (天之妖瞳) and Ultimate Martial Divine King (武极神王).</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ai XiaDeYu, Babel Novel
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Funstory
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2acb954c